module.exports = __webpack_public_path__ + "static/labelsNo-cb5209b61b60d02c1784022b202ac08a.png";